import { motion } from "framer-motion";
import { ArrowUpRight, Star } from "lucide-react";
import { SERVICES, waUrl } from "../data";

export const Services = () => {
  return (
    <section id="servicios" className="bg-ink py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div>
            <span className="text-xs uppercase tracking-[0.25em] font-bold text-electric">Servicios</span>
            <h2 className="font-heading font-bold text-white text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-none mt-5">
              Lo que hacemos<br />por tu hogar.
            </h2>
          </div>
          <p className="text-white/60 max-w-sm text-base leading-relaxed">
            Soluciones completas en PVC y aluminio en toda Cantabria, del primer corte al último sellado.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border-l border-t border-white/10">
          {SERVICES.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
              className={`group relative border-r border-b border-white/10 p-8 lg:p-10 overflow-hidden transition-colors duration-300 hover:bg-white/[0.03] ${s.featured ? "bg-electric/10" : ""}`}
              data-testid={`service-card-${i}`}
            >
              <div className="relative z-10">
                <div className="flex items-start justify-between">
                  <span className="font-heading font-light text-5xl text-white/20">{s.n}</span>
                  {s.featured ? (
                    <span className="inline-flex items-center gap-1.5 bg-electric text-white text-[11px] font-bold uppercase tracking-wider px-3 py-1.5">
                      <Star size={12} fill="currentColor" /> Destacado
                    </span>
                  ) : (
                    <ArrowUpRight className="text-white/30 group-hover:text-electric group-hover:-translate-y-1 group-hover:translate-x-1 transition-all duration-300" />
                  )}
                </div>
                <h3 className="font-heading font-semibold text-white text-2xl mt-12">{s.title}</h3>
                <p className="text-white/60 mt-3 text-sm leading-relaxed">{s.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="mt-14 flex justify-center">
          <a href={waUrl("Hola Ventanas Hondal, quiero solicitar un presupuesto gratuito.")} target="_blank" rel="noopener noreferrer" data-testid="services-quote-button" className="bg-electric text-white font-semibold px-8 py-4 hover:bg-white hover:text-ink transition-colors duration-300">
            Solicitar presupuesto gratuito
          </a>
        </div>
      </div>
    </section>
  );
};
